module.exports = __webpack_public_path__ + "static/screenshot3@2x-5762145f312d1a4cb67b20fb95c6f2c8.jpg";